import Environment from '../environment/Environment';
import { ObjToQueryString } from '../helpers/Helpers';

import { IPlanningPayload } from '../interfaces/sales-plan-planning.interface';
import { IPhasingPayload } from '../interfaces/sales-plan-phasing.interface';
import { IEditAllPayload } from '../interfaces/sales-plan-edit-all.interface';
import { IValidStorePayload } from '../interfaces/valid-store.interface';
import { IPWConfigPayload } from '../interfaces/plan-window-configuration.interface';
import { getRequest, HandlerResponse, postFileUploadRequest, putRequest } from './api';
import { genearteNewToken } from './NewToken.api';

export const GetSalesPlanData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/data/getSalesPlanData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateSalesPlanData = async (payload: IPlanningPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/data/editSalesPlanData${queryString}`, payload)
    .then((resp: any) => resp.text());
};

export const GetPhasingData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/phasing/salesPlan/PhasingGrid${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdatePhasingData = async (payload: IPhasingPayload[], queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/phasing/salesPlan/PhasingGrid/save${queryString}`, payload)
    .then((resp: any) => resp.text());
};

export const CopyDataToPlan = async (copyType: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/data/copyPlan/${copyType}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlan = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/data/freezePlan${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const FreezePlanEditAll = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/data/freezePlan${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplate = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/upload${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetEditAllData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/editall/displayEditAllScreen${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateEditAllData = async (payload: IEditAllPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/editall/salesPlan/editall/save${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetValidStoreData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/validstore/getGridData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdateValidStoreData = async (payload: IValidStorePayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/validstore/edit/save${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const InitializeValidStore = async (copyType: string, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/validstore/initialise/${copyType}${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const GetPWConfigData = async (queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return getRequest(`${Environment.API}/planningWindow/getGridData${queryString}`)
    .then((resp: any) => HandlerResponse(resp));
};

export const UpdatePWConfigData = async (payload: IPWConfigPayload, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return putRequest(`${Environment.API}/planningWindow/edit/save${queryString}`, payload)
    .then((resp: any) => HandlerResponse(resp));
};

export const ImportTemplateEditAll = async (file, queryParams?: any) => {
  genearteNewToken();
  const queryString = ObjToQueryString(queryParams);
  return postFileUploadRequest(`${Environment.API}/excel/editAll/uploadTemplateEditAll${queryString}`, file)
    .then((resp: any) => HandlerResponse(resp));
};
